import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './VMSolicitacoesPanel.css';

const TIPOS = [
  { value: 'cpu', label: '⚙ CPU', placeholder: 'Ex.: 8 vCPUs' },
  { value: 'memoria', label: '🧠 Memória', placeholder: 'Ex.: 16 GB' },
  { value: 'disco', label: '💾 Disco', placeholder: 'Ex.: +100 GB' },
  { value: 'desativacao', label: '⏻ Desativar VM', placeholder: '' },
];
const STATUS_META = {
  pendente:  { label: '🟡 Pendente',  cls: 'pendente' },
  concluida: { label: '🟢 Concluída', cls: 'concluida' },
  recusada:  { label: '🔴 Recusada',  cls: 'recusada' },
};
const TIPO_LABEL = { cpu: '⚙ CPU', memoria: '🧠 Memória', disco: '💾 Disco', desativacao: '⏻ Desativação', nova_vm: '🖥 Nova VM' };

const fmtData = (iso) => iso ? new Date(iso).toLocaleString('pt-BR') : '';

export default function VMSolicitacoesPanel({ vmid, onClose }) {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tipo, setTipo] = useState('cpu');
  const [valor, setValor] = useState('');
  const [observacao, setObservacao] = useState('');
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState(null);

  const fetchLista = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`/api/vms/${vmid}/solicitacoes`);
      setLista(res.data?.data || []);
    } catch (_) {}
    setLoading(false);
  }, [vmid]);

  useEffect(() => { fetchLista(); }, [fetchLista]);

  const handleSend = async () => {
    setSending(true);
    setMsg(null);
    try {
      await axios.post(`/api/vms/${vmid}/solicitacoes`, {
        tipo,
        valor: tipo === 'desativacao' ? '' : valor,
        observacao,
      });
      setMsg({ type: 'success', text: 'Solicitação enviada! A equipe será notificada.' });
      setValor('');
      setObservacao('');
      await fetchLista();
    } catch (e) {
      setMsg({ type: 'error', text: e.response?.data?.error || 'Erro ao enviar solicitação.' });
    }
    setSending(false);
  };

  const tipoMeta = TIPOS.find(t => t.value === tipo);

  return (
    <div className="vmsol-panel">
      <div className="vmsol-header">
        <span className="vmsol-title">📨 Solicitações</span>
        <button type="button" className="vmsol-close-btn" onClick={onClose}>×</button>
      </div>

      <div className="vmsol-form">
        <select className="vmsol-select" value={tipo} onChange={e => { setTipo(e.target.value); if (e.target.value === 'desativacao') setValor(''); }} disabled={sending}>
          {TIPOS.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
        {tipo !== 'desativacao' && (
          <input
            className="vmsol-input"
            placeholder={tipoMeta?.placeholder || 'Valor desejado'}
            value={valor}
            onChange={e => setValor(e.target.value)}
            disabled={sending}
            maxLength={255}
          />
        )}
        <input
          className="vmsol-input vmsol-obs"
          placeholder="Observação (opcional)"
          value={observacao}
          onChange={e => setObservacao(e.target.value)}
          disabled={sending}
          maxLength={255}
        />
        <button type="button" className="vmsol-send-btn" onClick={handleSend} disabled={sending}>
          {sending ? '...' : '📨 Enviar'}
        </button>
      </div>
      {msg && <div className={`vmsol-msg ${msg.type}`}>{msg.text}</div>}

      {loading ? (
        <div className="vmsol-loading">Carregando...</div>
      ) : lista.length === 0 ? (
        <div className="vmsol-empty">Nenhuma solicitação para esta VM.</div>
      ) : (
        <div className="vmsol-list">
          {lista.map(s => {
            const st = STATUS_META[s.status] || { label: s.status, cls: '' };
            return (
              <div className="vmsol-item" key={s.id}>
                <div className="vmsol-item-head">
                  <span className={`vmsol-status ${st.cls}`}>{st.label}</span>
                  <span className="vmsol-item-tipo">{TIPO_LABEL[s.tipo] || s.tipo}</span>
                  {s.valor && <span className="vmsol-item-valor">{s.valor}</span>}
                  <span className="vmsol-item-meta">{s.solicitante_sub ? `${s.solicitante} (${s.solicitante_sub})` : s.solicitante} · {fmtData(s.created_at)}</span>
                </div>
                {s.observacao && <div className="vmsol-item-obs">Obs.: {s.observacao}</div>}
                {s.resposta && (
                  <div className="vmsol-item-resposta">
                    <strong>Resposta</strong> ({s.respondido_por} · {fmtData(s.respondido_em)}): {s.resposta}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
